import "./Artwork3.scss"
import React from 'react'
import ImageSlider from '../ImageSlider/ImageSlider.jsx'

const slides = [
	{ url: "./images/loquat_bird.jpg", title: "loquat bird" },
];

const container3Styles = {
	width: "90%",
	height: "70%",
	position: "absolute",
	margin: "auto",
	top: "0", right: "0",
	bottom: "0", left: "0",
};

const Artwork3 = () => {
	return  <div className="art3-container">
					<div className="img3-container">
						<div style={container3Styles}>
							<ImageSlider slides={slides} />
						</div>
					</div>
			</div>
}

export default Artwork3